import React, { useEffect, useRef, useState } from "react";
import instance from "../instance";
import { ErrorIcon, SuccessIcon } from "../Svg";

const Success = () => {

  const [error,setError] = useState("")
  const [done,setDone] = useState(false)
  const [payLater,setPayLater] = useState(false)
  const hasMounted = useRef(false);


  const retrivesession = async ()=> {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');

    if(!sessionId) return setError('Veuillez remplire le formulaire')
    if(sessionId==="later") return setPayLater(true)

    try {
      const response = await instance.post('/retrieve-checkout-session',JSON.stringify({ sessionId }) ,{
      
        headers: {
          'Content-Type': 'application/json',
        },
   
      });
      console.log("DONE !");
      setDone(true)
    
      const session = response.data;
    } catch (e) {
      if(e.response && e.response.data.error==="Paiement déja passé") {
        // C'est ok c'est juste que le paiement est déja passé
        setDone(true)
        return
      }
      console.log(e);
      
      setError(e.response ? e.response.data.error : "Une Erreur Est Survenue");
      
    }
    
    
  }

  useEffect(() => {

    // retrivesession(sessionId)

    if (!hasMounted.current) {
      // Run your effect code here
      retrivesession()
      // Update the flag to indicate that the component has mounted
      hasMounted.current = true;
    }

  }, []);
  
  return <div className="hero">
    <div className="form__container" style={{borderRadius:"15px"}}>
      <div className="successContainer">
        {(error && error!=="Paiement ") ? <>
         <h4>Ooops, Une Erreur Est Survenue</h4>
         <ErrorIcon />
         <span className="error"> {error} </span> 
         
         </>: "" }
        {done ? <>
          <h5>Votre Réservation à été enregistré avec succée !</h5>
          <SuccessIcon />
          <span> Votre paiement a été accepté, vous allez recevoir un mail de confimation que vous pouvez présentez le jour de la brocante, verifiez vos spams ou courriers indésirables, Merci Pour Votre Confiance !</span>
        </>:""}
        {payLater ? <>
          <h5>Votre Réservation à été enregistré avec succée !</h5>
          <SuccessIcon />
          <span>Pour completer votre reservation, vous devez payer en espèce ou par chèque le jour de la brocante, Merci Pour Votre Confiance !</span>
        </>:""}

      </div>
    </div>
  </div>;
};

export default Success;
